<template>
    <div>

    <!-- <b-modal id="modalServico" data-backdrop="static" data-keyboard="false" size="xl" v-model="exibirItens" centered>
        <template #modal-header>
            <div class="col-10">
                <h4>Registre os serviços que você realizou!</h4>
            </div>
        </template> -->
        <div id="totalServico">
            <os-item-servico :os="os" v-for="(item, index) in items" :key="index" :item="item" :initAt="initAtendimento"
                @arrayServicos="insertArrayServicos" @limparArrayServicos="limparArrayServicos">
            </os-item-servico>
        </div>
        <!-- <template #modal-footer>
            <div class="w-100">
                <div class="row center" style="justify-content: center; ">
                    <b-button class="mr-2" variant="danger" size="lg" @click="$emit('showModalServicos')">
                        Fechar
                    </b-button>
                    <b-button size="lg" variant="success" @click="2">
                        Registrar Serviços
                    </b-button>
                </div>
            </div>
        </template>
    </b-modal> -->
    </div>
</template>
<script>
import OsItemServico from '@/components/Preventivas/OsItemServico'

export default {
    name: 'ModalItems',

    components: {
        OsItemServico,
    },

    data() {
        return {
            exibirItens: true,
            initAtendimento: false,
            totalServicos: [],
            validaOsExterna: false,
        }
    },

    methods: {
        limparArrayServicos(){
            this.totalServicos.length = 0
        },

        registrarServicos() {
            if (this.todosItensTrue() == this.todosItensPecas()) {
                this.$emit('showModalServicos')
                this.$root.confirmIdentity({
                    onConfirmIdentity: (tecnicoId) => {
                        this.$store.dispatch('os/getDetails', {
                            nrSequencial: this.$route.params.id
                        }).then(response => {
                            // if (true) {
                            const execucao = {
                                todosServicos: this.totalServicos,
                                nrSeqOs: this.$route.params.id,
                                tecnicoId: tecnicoId,
                                dt_inicial: response.data.dt_inicial
                            }

                            this.$store.dispatch('osItemExecucao/registrarServicos', { data: execucao }).then(response => {
                                this.$swal.fire({
                                    title: this.$t('Sucesso!'),
                                    text: this.$t('Serviços registrado com sucesso'),
                                    icon: 'success'
                                })
                            }).catch((error) => {
                                console.log(error)
                            })
                        })

                    }
                }, this.validaOsExterna)
            } else {
                this.$swal.fire({
                    title: this.$t('Oops!'),
                    text: this.$t('Selecione todos os serviços!'),
                    icon: 'error'
                })
            }
        },

        todosItensPecas() {
            const allItens = this.$store.getters['osItem/itemsPreventiva']

            let validador = []

            allItens.forEach(item => {
                if (item.item.tipo.nr_sequencial == 3) {
                    validador.push(item)
                }
            })

            return validador.length
        },

        todosItensTrue() {
            const allCheckBox = document.querySelectorAll('.checkServicos')

            let validador = []

            allCheckBox.forEach(checkBox => {
                if (checkBox.checked) {
                    validador.push(checkBox)
                }
            })

            return validador.length
        },

        insertArrayServicos(value) {
            if (!this.totalServicos.includes(value)) {
                this.totalServicos.push(value)
            } else {
                const index = this.totalServicos.indexOf(value)

                this.totalServicos.splice(index, 1)
            }

            console.log(this.totalServicos)

        }
    },

    computed: {
        items() {
            return this.$store.getters['osItem/itemsPreventiva']
        },
    
    },
    created(){
        this.$store.dispatch('osItem/fetchFromApiPreventiva', { nrSeqOs: this.$route.params.id })
        console.log(this.$store.getters['osItem/itemsPreventiva'])
    }
}
</script>
<style scoped>
#modalServico {
    pointer-events: none !important;
    height: 750px !important;
}

.close {
    display: none !important;
}

.modal-footer {
    margin-bottom: 20px;
}

#totalServico {
    height: 466px !important;
    overflow-x: auto !important;
}

.modal-content {
    height: 700px !important;
}

</style>